/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypelabelthinker3Inputs */



/**
* | output |
* | --- |
* | "The Doomer" |
*
* @param {Personalityarchetypelabelthinker3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypelabelthinker3 = /** @type {((inputs?: Personalityarchetypelabelthinker3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypelabelthinker3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The Doomer")
	if (locale === "es") return /** @type {LocalizedString} */ ("El Pensador Profundo")
	return /** @type {LocalizedString} */ ("Думер")
});
export { personalityarchetypelabelthinker3 as "personalityArchetypeLabelThinker" }